import { render, staticRenderFns } from "./CareerRoadmap.vue?vue&type=template&id=67b10ff4&scoped=true"
import script from "./CareerRoadmap.vue?vue&type=script&lang=js"
export * from "./CareerRoadmap.vue?vue&type=script&lang=js"
import style0 from "./CareerRoadmap.vue?vue&type=style&index=0&id=67b10ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b10ff4",
  null
  
)

export default component.exports